// // src/pages/AgentStrategy.js
// import React, { useState, useEffect, useContext } from 'react';
// import {
//   Container,
//   Typography,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   FormControl,
//   FormLabel,
//   Button,
//   Card,
//   CardContent,
//   Checkbox,
//   FormGroup,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import ProgressContext from '../context/ProgressContext';
// import { UserContext } from '../context/UserContext';
// import { useNavigate } from 'react-router-dom';
// import HorizontalStepper from '../components/HorizontalStepper';
// import axios from 'axios';
// import BackButton from '../components/BackButton';
// function AgentStrategy() {
//   const { steps, currentStep, nextStep, setCurrentStep } = useContext(ProgressContext);
//   const {
//     segmentName,
//     agentStrategyState,
//     setAgentStrategyState,
//     setAgentStrategy,
//   } = useContext(UserContext);
//   const navigate = useNavigate();
//   // Use context state as initial values
//   const [strategy, setStrategy] = useState(agentStrategyState.strategy || '1');
//   const [recommendationType, setRecommendationType] = useState(
//     agentStrategyState.recommendationType || '1.1'
//   );
//   const [productOption, setProductOption] = useState(
//     agentStrategyState.productOption || 'All'
//   );
//   const [selectedProducts, setSelectedProducts] = useState(
//     agentStrategyState.selectedProducts || []
//   );
//   const [productList, setProductList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   // Update context state whenever local state changes
//   useEffect(() => {
//     setAgentStrategyState({
//       strategy,
//       recommendationType,
//       productOption,
//       selectedProducts,
//     });
//   }, [
//     strategy,
//     recommendationType,
//     productOption,
//     selectedProducts,
//     setAgentStrategyState,
//   ]);
//   // Set the current step on component mount
//   useEffect(() => {
//     const stepIndex = steps.findIndex(
//       (step) => step.path === '/dashboard/agent-strategy'
//     );
//     if (stepIndex !== -1) {
//       setCurrentStep(stepIndex);
//     }
//   }, [steps, setCurrentStep]);
//   // Fetch product list based on segmentName
//   useEffect(() => {
//     const fetchFilteredSegmentData = async () => {
//       try {
//         const response = await axios.get('http://localhost:8000/liva/api/filtered-segment-data', {
//           params: { segment_name: segmentName },
//           withCredentials: true,
//         });
//         const filteredSegmentData = response.data.filtered_segment_data;
//         const productNames = filteredSegmentData.map((item) => item['Product Name']);
//         setProductList(productNames);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching filtered segment data:', error);
//         setLoading(false);
//       }
//     };
//     if (segmentName) {
//       fetchFilteredSegmentData();
//     }
//   }, [segmentName]);
//   const handleProceed = () => {
//     const currentAgentStrategy = {
//       strategy,
//       recommendation_type: strategy === '1' ? recommendationType : null,
//       product_option: strategy === '1' ? productOption : null,
//       selected_products: selectedProducts,
//     };
//     // Store agent strategy in context
//     setAgentStrategy(currentAgentStrategy);
//     // Advance to next step and mark current step as completed
//     nextStep();
//     // Navigate to the next page
//     const nextPath = steps[currentStep + 1]?.path;
//     if (nextPath) {
//       navigate(nextPath);
//     } else {
//       // If no next path, stay on the current page
//       console.warn('No next path found');
//     }
//   };
//   const handleProductSelection = (event) => {
//     const { value } = event.target;
//     setSelectedProducts((prevSelected) =>
//       prevSelected.includes(value)
//         ? prevSelected.filter((product) => product !== value)
//         : [...prevSelected, value]
//     );
//   };
//   // Determine the label for the Next button
//   const nextStepLabel = steps[currentStep + 1]?.label
//     ? `Next to ${steps[currentStep + 1].label}`
//     : 'Finish';
//   return (
//     <Container maxWidth="md" sx={{ mt: 4 }}>
//       <HorizontalStepper />
//       <BackButton />
//       <motion.div
//         initial={{ opacity: 0, x: -50 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
//           2️⃣ Agent Strate
//         </Typography>
//         <Card
//           sx={{
//             mt: 2,
//             backgroundColor: 'rgba(255, 255, 255, 0.7)', // Semi-transparent white background
//             backdropFilter: 'blur(10px)', // Blur effect for matching background
//             boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)', // Optional shadow for better visibility
//             borderRadius: 2, // Rounded corners
//           }}
//         >
//           <CardContent>
//             <FormControl component="fieldset">
//               <FormLabel component="legend">Select a strategy</FormLabel>
//               <RadioGroup
//                 value={strategy}
//                 onChange={(e) => {
//                   setStrategy(e.target.value);
//                   setSelectedProducts([]); // Reset selected products when strategy changes
//                 }}
//               >
//                 <FormControlLabel
//                   value="1"
//                   control={<Radio />}
//                   label="1. Customer-Specific Product Recommendations"
//                 />
//                 <FormControlLabel
//                   value="2"
//                   control={<Radio />}
//                   label="2. Manual Recommendations"
//                 />
//               </RadioGroup>
//             </FormControl>
//             {strategy === '1' && (
//               <>
//                 <FormControl component="fieldset" sx={{ mt: 2 }}>
//                   <FormLabel component="legend">Select recommendation type</FormLabel>
//                   <RadioGroup
//                     value={recommendationType}
//                     onChange={(e) => setRecommendationType(e.target.value)}
//                   >
//                     <FormControlLabel
//                       value="1.1"
//                       control={<Radio />}
//                       label="1.1 Single Product Recommendations"
//                     />
//                     <FormControlLabel
//                       value="1.2"
//                       control={<Radio />}
//                       label="1.2 Product Mix Recommendations"
//                     />
//                     <FormControlLabel
//                       value="1.3"
//                       control={<Radio />}
//                       label="1.3 Unsure? Get Both Recommendations"
//                     />
//                   </RadioGroup>
//                 </FormControl>
//                 <FormControl component="fieldset" sx={{ mt: 2 }}>
//                   <FormLabel component="legend">Select product option</FormLabel>
//                   <RadioGroup
//                     value={productOption}
//                     onChange={(e) => {
//                       setProductOption(e.target.value);
//                       setSelectedProducts([]); // Reset selected products when option changes
//                     }}
//                   >
//                     <FormControlLabel
//                       value="All"
//                       control={<Radio />}
//                       label="All Products in Segment"
//                     />
//                     <FormControlLabel
//                       value="Selected"
//                       control={<Radio />}
//                       label="Selected Products Only"
//                     />
//                   </RadioGroup>
//                 </FormControl>
//                 {productOption === 'Selected' && (
//                   <FormControl component="fieldset" sx={{ mt: 2 }}>
//                     <FormLabel component="legend">Select products</FormLabel>
//                     {loading ? (
//                       <Typography>Loading products...</Typography>
//                     ) : (
//                       <FormGroup>
//                         {productList.map((productName) => (
//                           <FormControlLabel
//                             key={productName}
//                             control={
//                               <Checkbox
//                                 checked={selectedProducts.includes(productName)}
//                                 onChange={handleProductSelection}
//                                 value={productName}
//                               />
//                             }
//                             label={productName}
//                           />
//                         ))}
//                       </FormGroup>
//                     )}
//                   </FormControl>
//                 )}
//               </>
//             )}
//             {strategy === '2' && (
//               <FormControl component="fieldset" sx={{ mt: 2 }}>
//                 <FormLabel component="legend">Select products</FormLabel>
//                 {loading ? (
//                   <Typography>Loading products...</Typography>
//                 ) : (
//                   <FormGroup>
//                     {productList.map((productName) => (
//                       <FormControlLabel
//                         key={productName}
//                         control={
//                           <Checkbox
//                             checked={selectedProducts.includes(productName)}
//                             onChange={handleProductSelection}
//                             value={productName}
//                           />
//                         }
//                         label={productName}
//                       />
//                     ))}
//                   </FormGroup>
//                 )}
//               </FormControl>
//             )}
//           </CardContent>
//         </Card>
//         {/* Next button at the bottom */}
//         <Button
//           variant="contained"
//           color="primary"
//           sx={{ mt: 4, mb: 4 }}
//           onClick={handleProceed}
//         >
//           {nextStepLabel}
//         </Button>
//       </motion.div>
//     </Container>
//   );
// }
// export default AgentStrategy;



// // src/pages/AgentStrategy.js
// import React, { useState, useEffect, useContext } from 'react';
// import {
//   Container,
//   Typography,
//   RadioGroup,
//   FormControlLabel,
//   Radio,
//   FormControl,
//   FormLabel,
//   Button,
//   Card,
//   CardContent,
//   Checkbox,
//   FormGroup,
//   Grid,
//   Box,
//   CardMedia,
// } from '@mui/material';
// import { motion } from 'framer-motion';
// import ProgressContext from '../context/ProgressContext';
// import { UserContext } from '../context/UserContext';
// import { useNavigate } from 'react-router-dom';
// import HorizontalStepper from '../components/HorizontalStepper';
// import axios from 'axios';
// import BackButton from '../components/BackButton';
// import apiClient from '../utils/apiClient';
// function AgentStrategy() {
//   const { steps, currentStep, nextStep, setCurrentStep } = useContext(ProgressContext);
//   const {
//     segmentName,
//     agentStrategyState,
//     setAgentStrategyState,
//     setAgentStrategy,
//     setPitchResponse,
//     setSelectedProducts,
//     setSelectedProductCodes,
//   } = useContext(UserContext);
//   const navigate = useNavigate();
//   const [strategy, setStrategy] = useState(agentStrategyState.strategy || '1');
//   const [recommendationType, setRecommendationType] = useState(
//     agentStrategyState.recommendationType || '1.1'
//   );
//   const [productOption, setProductOption] = useState(
//     agentStrategyState.productOption || 'All'
//   );
//   const [localSelectedProducts, setLocalSelectedProducts] = useState(
//     agentStrategyState.selectedProducts || []
//   );
//   const [productList, setProductList] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [processing, setProcessing] = useState(false);
//   // Update context state whenever local state changes
//   useEffect(() => {
//     setAgentStrategyState({
//       strategy,
//       recommendationType: strategy === '1' ? recommendationType : null,
//       productOption: strategy === '1' ? productOption : null,
//       selectedProducts: localSelectedProducts,
//     });
//   }, [strategy, recommendationType, productOption, localSelectedProducts, setAgentStrategyState]);
//   // Set the current step on component mount
//   useEffect(() => {
//     const stepIndex = steps.findIndex((step) => step.path === '/dashboard/agent-strategy');
//     if (stepIndex !== -1) {
//       setCurrentStep(stepIndex);
//     }
//   }, [steps, setCurrentStep]);
//   // Fetch product list based on segmentName
//   useEffect(() => {
//     const fetchFilteredSegmentData = async () => {
//       try {
//         // const response = await axios.get('http://localhost:8000/liva/api/filtered-segment-data', {
//         //   params: { segment_name: segmentName },
//         //   withCredentials: true,
//         // });

//         const response = await apiClient.post('/filtered-segment-data', {
//           segmentName: segmentName,
//           withCredentials: true,
//         });
//         const filteredSegmentData = response.data.filtered_segment_data;
//         const productNames = filteredSegmentData.map((item) => item['Product Name']);
//         setProductList(productNames);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching filtered segment data:', error);
//         setLoading(false);
//       }
//     };
//     if (segmentName) {
//       fetchFilteredSegmentData();
//     }
//   }, [segmentName]);
//   const handleProceed = async () => {
//     const currentAgentStrategy = {
//       strategy,
//       recommendation_type: strategy === '1' ? recommendationType : null,
//       product_option: strategy === '1' ? productOption : null,
//       selected_products: localSelectedProducts,
//     };
//     setAgentStrategy(currentAgentStrategy);
//     if (strategy === '1') {
//       // Normal flow
//       nextStep();
//       const nextPath = steps[currentStep + 1]?.path;
//       if (nextPath) {
//         navigate(nextPath);
//       } else {
//         console.warn('No next path found');
//       }
//     } else if (strategy === '2') {
//       // Manual Recommendations
//       setProcessing(true);
//       try {
//         const response = await axios.post(
//           // 'http://localhost:8000/liva/api/manual-product-pitch',
//           '/api/manual-product-pitch',
//           {
//             agent_strategy: currentAgentStrategy,
//             segment_name: segmentName,
//           },
//           { withCredentials: true }
//         );
//         const data = response.data;
//         // Store pitch and product codes
//         setPitchResponse(data.pitch_response);
//         setSelectedProducts(localSelectedProducts);
//         setSelectedProductCodes(data.selected_product_codes);
//         // Skip product recommendation and go to EBI generation
//         nextStep(); // skip product recommendation step
//         nextStep(); // go to EBI step
//         const ebiPath = steps[currentStep + 2]?.path;
//         if (ebiPath) {
//           navigate(ebiPath);
//         } else {
//           console.warn('No EBI generation path found');
//         }
//       } catch (error) {
//         console.error('Error generating manual pitch:', error);
//       } finally {
//         setProcessing(false);
//       }
//     }
//   };
//   const handleProductSelection = (event) => {
//     const { value } = event.target;
//     setLocalSelectedProducts((prevSelected) =>
//       prevSelected.includes(value)
//         ? prevSelected.filter((product) => product !== value)
//         : [...prevSelected, value]
//     );
//   };
//   const nextStepLabel =
//     strategy === '2'
//       ? 'Proceed to EBI Generation'
//       : steps[currentStep + 1]?.label
//       ? `Next to ${steps[currentStep + 1].label}`
//       : 'Finish';
//   return (
//     <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
//       <HorizontalStepper />
//       <BackButton />
//       <motion.div
//         initial={{ opacity: 0, x: -50 }}
//         animate={{ opacity: 1, x: 0 }}
//         transition={{ duration: 0.5 }}
//       >
//         <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
//           Agent Strategy
//         </Typography>
//         <Grid container spacing={4}>
//           {/* Select a Strategy Card */}
//           <Grid item xs={12} md={6}>
//             <Card
//               sx={{
//                 backgroundColor: 'rgba(255, 255, 255, 0.85)',
//                 backdropFilter: 'blur(10px)',
//                 boxShadow: 3,
//                 borderRadius: 2,
//                 height: '100%',
//               }}
//             >
//               <CardMedia
//                 component="img"
//                 height="100"
//                 image="/agentstrategy.png"
//                 alt="agentstrategy"
//                 className="blinking-image"
//                 style={{ width: '200', height: 'auto' }} // Adjust size
//               />
//               <CardContent>
//                 <FormControl component="fieldset">
//                   <FormLabel component="legend" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 'bold' }}>
//                     Select a Strategy
//                   </FormLabel>
//                   <RadioGroup
//                     value={strategy}
//                     onChange={(e) => {
//                       setStrategy(e.target.value);
//                       setLocalSelectedProducts([]);
//                     }}
//                   >
//                     <FormControlLabel
//                       value="1"
//                       control={<Radio />}
//                       label="1. Requirement based recommendation"
//                     />
//                     <FormControlLabel
//                       value="2"
//                       control={<Radio />}
//                       label="2. Profile based recommendation"
//                     />
//                   </RadioGroup>
//                 </FormControl>
//               </CardContent>
//             </Card>
//           </Grid>
//           {/* Select Recommendation Type Card */}
//           {strategy === '1' && (
//             <Grid item xs={12} md={6}>
//               <Card
//                 sx={{
//                   backgroundColor: 'rgba(255, 255, 255, 0.85)',
//                   backdropFilter: 'blur(10px)',
//                   boxShadow: 3,
//                   borderRadius: 2,
//                   height: '100%',
//                 }}
//               >
//                 <CardMedia
//                 component="img"
//                 height="auto"
//                 image="/recommendationtype.png"
//                 alt="recommendationtype"
//                 className="blinking-image"
//                 style={{ width: 'auto', height: 'auto' }} // Adjust size
//               />
//                 <CardContent>
//                   <FormControl component="fieldset">
//                     <FormLabel component="legend" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 'bold' }}>
//                       Select Recommendation Type
//                     </FormLabel>
//                     <RadioGroup
//                       value={recommendationType}
//                       onChange={(e) => setRecommendationType(e.target.value)}
//                     >
//                       <FormControlLabel
//                         value="1.1"
//                         control={<Radio />}
//                         label="1.1 Single Product Recommendations"
//                       />
//                       <FormControlLabel
//                         value="1.2"
//                         control={<Radio />}
//                         label="1.2 Product Mix Recommendations"
//                       />
//                       <FormControlLabel
//                         value="1.3"
//                         control={<Radio />}
//                         label="1.3 Unsure? Get Both Recommendations"
//                       />
//                     </RadioGroup>
//                   </FormControl>
//                 </CardContent>
//               </Card>
//             </Grid>
//           )}
//           {/* Select Product Only Card */}
//           <Grid item xs={12}>
//             <Card
//               sx={{
//                 backgroundColor: 'rgba(255, 255, 255, 0.85)',
//                 backdropFilter: 'blur(10px)',
//                 boxShadow: 3,
//                 borderRadius: 2,
//               }}
//             >
//               <CardContent>
//                 <FormControl component="fieldset">
//                   <FormLabel component="legend" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 'bold' }}>
//                     Select Product Option
//                   </FormLabel>
//                   <RadioGroup
//                     value={productOption}
//                     onChange={(e) => {
//                       setProductOption(e.target.value);
//                       setLocalSelectedProducts([]);
//                     }}
//                   >
//                     <FormControlLabel
//                       value="All"
//                       control={<Radio />}
//                       label="All Products in Segment"
//                     />
//                     <FormControlLabel
//                       value="Selected"
//                       control={<Radio />}
//                       label="Selected Products Only"
//                     />
//                   </RadioGroup>
//                 </FormControl>
//                 {productOption === 'Selected' && (
//                   <Box sx={{ mt: 3 }}>
//                     <FormControl component="fieldset">
//                       <FormLabel component="legend" sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 'bold' }}>
//                         Select Products
//                       </FormLabel>
//                       {loading ? (
//                         <Typography>Loading products...</Typography>
//                       ) : (
//                         <FormGroup>
//                           {productList.map((productName) => (
//                             <FormControlLabel
//                               key={productName}
//                               control={
//                                 <Checkbox
//                                   checked={localSelectedProducts.includes(productName)}
//                                   onChange={handleProductSelection}
//                                   value={productName}
//                                 />
//                               }
//                               label={productName}
//                             />
//                           ))}
//                         </FormGroup>
//                       )}
//                     </FormControl>
//                   </Box>
//                 )}
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>
//         {/* Next Button */}
//         <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
//           <Button
//             variant="contained"
//             color="primary"
//             size="large"
//             onClick={handleProceed}
//             disabled={processing}
//             sx={{
//               paddingX: 4,
//               paddingY: 1.5,
//               fontSize: '1rem',
//               borderRadius: 2,
//               boxShadow: 3,
//               '&:hover': {
//                 boxShadow: 6,
//               },
//             }}
//           >
//             {processing ? 'Processing...' : nextStepLabel}
//           </Button>
//         </Box>
//       </motion.div>
//     </Container>
//   );
// }
// export default AgentStrategy;




// src/pages/AgentStrategy.js
import React, { useState, useEffect, useContext } from 'react';
import {
  Container,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormGroup,
  Grid,
  Box,
  IconButton,
  Tooltip,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import { motion } from 'framer-motion';
import ProgressContext from '../context/ProgressContext';
import { UserContext } from '../context/UserContext';
import { useNavigate } from 'react-router-dom';
import HorizontalStepper from '../components/HorizontalStepper';
import axios from 'axios';
import BackButton from '../components/BackButton';
// Icons
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import DescriptionIcon from '@mui/icons-material/Description';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import ArticleIcon from '@mui/icons-material/Article';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import DOMPurify from 'dompurify';
// Import images (adjust paths as needed)
import strategyImg from '../pages/strategy.png';
import recommendationImg from '../pages/recommendation.png';
import optionsImg from '../pages/options.png';
import apiClient from '../utils/apiClient';
/**
 * ImageSlideshow Component
 * 
 * Props:
 * - images: Array of image sources to be displayed in the slideshow.
 * - slideInterval (number): Time (in milliseconds) for each slide (default is 3000ms = 3 seconds).
 * - boxHeight (string): Height of the slideshow container (e.g., "300px"). 
 *
 * To update the image size: Adjust the 'width' and 'height' properties in the inline style of the <img>.
 * To update the container size: Change the 'boxHeight' prop when using the component.
 * To update the slideshow interval: Change the 'slideInterval' prop (in milliseconds).
 */
const ImageSlideshow = ({ images, slideInterval = 3000, boxHeight = '300px' }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, slideInterval); // slide change interval in milliseconds
    return () => clearInterval(interval);
  }, [images, slideInterval]);
useEffect(() => {
   const handlePopState = () => window.history.pushState(null, "", window.location.href);
   window.history.pushState(null, "", window.location.href);
   window.addEventListener("popstate", handlePopState);
   return () => window.removeEventListener("popstate", handlePopState);
}, []);

  return (
    <Box sx={{ width: '100%', height: boxHeight, overflow: 'hidden', mb: 2 }}>
      <img
        src={images[currentIndex]}
        alt={`Slide ${currentIndex}`}
        style={{
          width: '100%',   // Adjust image width here
          height: '100%',  // Adjust image height here
          objectFit: 'cover', // Maintains aspect ratio while covering the container
        }}
      />
    </Box>
  );
};
function AgentStrategy() {
  const { steps, currentStep, nextStep, setCurrentStep } = useContext(ProgressContext);
  const { setUserNTID, setUserChannel, userNTID } = useContext(UserContext);

  const {
    segmentName,
    agentStrategyState,
    setAgentStrategyState,
    setAgentStrategy,
    setPitchResponse,
    setSelectedProducts,
    setSelectedProductCodes,
    segmentData,
  } = useContext(UserContext);
  const navigate = useNavigate();
  // Strategy & RecommendationType
  const [strategy, setStrategy] = useState(agentStrategyState.strategy || '1');
  const [recommendationType, setRecommendationType] = useState(
    agentStrategyState.recommendationType || '1.1'
  );
  // Product Option
  const [productOption, setProductOption] = useState(
    agentStrategyState.productOption || 'All'
  );
  // Product list & selected products (for manual strategy)
  const [productList, setProductList] = useState([]);
  const [localSelectedProducts, setLocalSelectedProducts] = useState(
    agentStrategyState.selectedProducts || []
  );
  const [expandedCardIndex, setExpandedCardIndex] = useState(null);
  const [loading, setLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  // STEP INDICATOR
  useEffect(() => {
    const stepIndex = steps.findIndex((step) => step.path === '/dashboard/agent-strategy');
    if (stepIndex !== -1) {
      setCurrentStep(stepIndex);
    }
  }, [steps, setCurrentStep]);
  // FETCH product list for manual selection
  useEffect(() => {
    const fetchFilteredSegmentData = async () => {
      try {
        const response = await apiClient.post('/filtered-segment-data', {
          params: { segment_name: segmentName, ntID: userNTID},
          withCredentials: true,
        });
        const filteredSegmentData = response.data.filtered_segment_data;
        const productNames = filteredSegmentData.map((item) => item['Product Name']);
        setProductList(productNames);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching filtered segment data:', error);
        setLoading(false);
      }
    };
    if (segmentName) {
      fetchFilteredSegmentData();
    } else {
      setLoading(false);
    }
  }, [segmentName]);
  // Sync local changes back to context
  useEffect(() => {
    setAgentStrategyState({
      strategy,
      recommendationType: strategy === '1' ? recommendationType : null,
      productOption,
      selectedProducts: localSelectedProducts,
    });
  }, [strategy, recommendationType, productOption, localSelectedProducts, setAgentStrategyState]);
  const handleProceed = async () => {
    const currentAgentStrategy = {
      strategy,
      recommendation_type: strategy === '1' ? recommendationType : null,
      product_option: strategy === '1' ? 'All' : 'Selected', // derived
      selected_products: localSelectedProducts,
    };
    setAgentStrategy(currentAgentStrategy);
    if (strategy === '1') {
      // Normal flow => next step
      nextStep();
      const nextPath = steps[currentStep + 1]?.path;
      if (nextPath) {
        navigate(nextPath);
      } else {
        console.warn('No next path found');
      }
    } else if (strategy === '2') {
      // Manual => skip product recommendation -> EBI
      setProcessing(true);
      try {
        const response = await apiClient.post(
          '/manual-product-pitch',
          {
            agent_strategy: currentAgentStrategy,
            segment_name: segmentName,
            ntID: userNTID
          },
          { withCredentials: true }
        );
        const data = response.data;
        setPitchResponse(data.pitch_response);
        setSelectedProducts(localSelectedProducts);
        setSelectedProductCodes(data.selected_product_codes);
        // skip next step => go to EBI
        nextStep();
        nextStep();
        const ebiPath = steps[currentStep + 2]?.path;
        if (ebiPath) {
          navigate(ebiPath);
        } else {
          console.warn('No EBI generation path found');
        }
      } catch (error) {
        console.error('Error generating manual pitch:', error);
      } finally {
        setProcessing(false);
      }
    }
  };
  const handleCheckboxChange = (event) => {
    const { value } = event.target;
    setLocalSelectedProducts((prev) =>
      prev.includes(value) ? prev.filter((p) => p !== value) : [...prev, value]
    );
  };
  const toggleCardExpand = (index) => {
    setExpandedCardIndex(expandedCardIndex === index ? null : index);
  };
  const openVideoPopup = (videoLink) => {
    if (!videoLink) return;
    const width = 800;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    window.open(videoLink, 'videoPopup', `width=${width},height=${height},top=${top},left=${left}`);
  };
  const openExternalLink = (url) => {
    if (!url) return;
    const width = 800;
    const height = 600;
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;
    window.open(url, '_blank', `width=${width},height=${height},top=${top},left=${left}`);
  };
  const getIconForLabel = (label) => {
    switch (label) {
      case 'brochure':
        return <DescriptionIcon />;
      case 'product_ppt':
        return <PictureAsPdfIcon />;
      case 'terms_and_conditions':
        return <InsertDriveFileIcon />;
      case 'one_pager':
        return <ArticleIcon />;
      default:
        return null;
    }
  };
  // Button label
  const nextStepLabel =
    strategy === '2'
      ? 'Proceed to EBI Generation'
      : steps[currentStep + 1]?.label
      ? `Next to ${steps[currentStep + 1].label}`
      : 'Finish';
  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <HorizontalStepper />
      <BackButton />
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Typography variant="h5" gutterBottom sx={{ mt: 4 }}>
          2️⃣ Agent Strategy
        </Typography>
        {/*
          New slideshow box added here.
          - To change the slideshow interval, modify the 'slideInterval' prop (in milliseconds).
          - To change the slideshow container height, update the 'boxHeight' prop.
          - To change image size, adjust the style properties in the ImageSlideshow component.
        */}
        <ImageSlideshow
          images={[strategyImg, recommendationImg, optionsImg]}
          slideInterval={3000} // 3000ms = 3 seconds per slide; adjust as needed
          boxHeight="300px"    // Adjust the box height (and therefore image height) here
        />
        {/* Row of 3 cards */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          {/* 1) Select a Strategy */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(10px)',
                boxShadow: 3,
                borderRadius: 2,
                height: '100%',
              }}
            >
              <CardContent>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel
                    component="legend"
                    sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 'bold' }}
                  >
                    Select a Strategy
                  </FormLabel>
                  {/* Removed image; only the RadioGroup is shown */}
                  <RadioGroup
                    value={strategy}
                    onChange={(e) => {
                      setStrategy(e.target.value);
                      // Reset product option & selected products
                      setProductOption(e.target.value === '1' ? 'All' : 'Selected');
                      setLocalSelectedProducts([]);
                    }}
                  >
                    <FormControlLabel
                      value="1"
                      control={<Radio />}
                      label="Customer-Specific Recommendations"
                    />
                    <FormControlLabel
                      value="2"
                      control={<Radio />}
                      label="Manual Recommendations"
                    />
                  </RadioGroup>
                </FormControl>
              </CardContent>
            </Card>
          </Grid>
          {/* 2) Select Recommendation Type */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(10px)',
                boxShadow: 3,
                borderRadius: 2,
                height: '100%',
              }}
            >
              <CardContent>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel
                    component="legend"
                    sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 'bold' }}
                  >
                    Select Recommendation Type
                  </FormLabel>
                  {/* Removed image; only the radio options or placeholder text is shownOrhyD*/}
                  {strategy === '1' ? (
                    <RadioGroup
                      value={recommendationType}
                      onChange={(e) => setRecommendationType(e.target.value)}
                    >
                      <FormControlLabel
                        value="1.1"
                        control={<Radio />}
                        label="Single Product Recommendations"
                      />
                      <FormControlLabel
                        value="1.2"
                        control={<Radio />}
                        label="Product Mix Recommendations"
                      />
                      <FormControlLabel
                        value="1.3"
                        control={<Radio />}
                        label="Unsure? Get Both Recommendations"
                      />
                    </RadioGroup>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      Not applicable for Manual Recommendations
                    </Typography>
                  )}
                </FormControl>
              </CardContent>
            </Card>
          </Grid>
          {/* 3) Select Product Option */}
          <Grid item xs={12} md={4}>
            <Card
              sx={{
                backgroundColor: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(10px)',
                boxShadow: 3,
                borderRadius: 2,
                height: '100%',
              }}
            >
              <CardContent>
                <FormControl component="fieldset" fullWidth>
                  <FormLabel
                    component="legend"
                    sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 'bold' }}
                  >
                    Select Product Option
                  </FormLabel>
                  {/* Removed image; only the RadioGroup is shown */}
                  <RadioGroup
                    value={productOption}
                    onChange={(e) => {
                      setProductOption(e.target.value);
                      setLocalSelectedProducts([]);
                    }}
                  >
                    <FormControlLabel
                      value="All"
                      control={<Radio />}
                      label="All Products in Segment"
                      disabled={strategy === '2'} // Manual => force "Selected"
                    />
                    <FormControlLabel
                      value="Selected"
                      control={<Radio />}
                      label="Selected Products Only"
                      disabled={strategy === '1'} // Auto => force "All"
                    />
                  </RadioGroup>
                </FormControl>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {/* 4) Show "Select Products" if manual strategy => productOption = "Selected" */}
        {strategy === '2' && productOption === 'Selected' && (
          <Card
            sx={{
              backgroundColor: 'rgba(255, 255, 255, 0.85)',
              backdropFilter: 'blur(10px)',
              boxShadow: 3,
              borderRadius: 2,
              mb: 3,
            }}
          >
            <CardContent>
              <FormControl component="fieldset">
                <FormLabel
                  component="legend"
                  sx={{ mb: 2, fontSize: '1.1rem', fontWeight: 'bold' }}
                >
                  Select Products
                </FormLabel>
                {loading ? (
                  <Typography>Loading products...</Typography>
                ) : (
                  <FormGroup row>
                    {productList.map((productName) => (
                      <FormControlLabel
                        key={productName}
                        control={
                          <Checkbox
                            checked={localSelectedProducts.includes(productName)}
                            onChange={handleCheckboxChange}
                            value={productName}
                          />
                        }
                        label={productName}
                        sx={{ mr: 4, mb: 1 }} // spacing
                      />
                    ))}
                  </FormGroup>
                )}
              </FormControl>
            </CardContent>
          </Card>
        )}
        {/* 5) Reference: Show all product cards for user reference */}
        {segmentData && segmentData.products && segmentData.products.length > 0 && (
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              Product Details
            </Typography>
            <Grid container spacing={2}>
              {segmentData.products.map((product, index) => {
                const isExpanded = expandedCardIndex === index;
                return (
                  <Grid item xs={12} sm={isExpanded ? 12 : 4} key={index}>
                    <Card
                      sx={{
                        position: 'relative',
                        transition: 'all 0.5s ease',
                        p: 2,
                        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.2)',
                        borderRadius: 2,
                        height: isExpanded ? 'auto' : '400px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                      }}
                    >
                      {!isExpanded && (
                        <>
                          {/* Condensed View */}
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                              {product.product_logo && (
                                <img
                                  src={product.product_logo}
                                  alt={product.product_name}
                                  style={{
                                    width: '50px',
                                    height: '50px',
                                    marginRight: '8px',
                                    objectFit: 'contain',
                                  }}
                                />
                              )}
                              <Box>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
                                  {product.product_name}
                                </Typography>
                                <Typography variant="body2">
                                  {product.product_category} | {product.product_filter}
                                </Typography>
                              </Box>
                            </Box>
                            <IconButton onClick={() => toggleCardExpand(index)}>
                              <ArrowForwardIosIcon />
                            </IconButton>
                          </Box>
                          <Box sx={{ borderBottom: '1px solid #ccc', my:1 }} />
                          {/* Key Features */}
                          {product.key_features && product.key_features.length > 0 && (
                            <List dense>
                              {product.key_features.map((kf, kfIndex) =>(
                                <ListItem key={kfIndex} disablePadding>
                                  <ListItemIcon>
                                    <CheckCircleIcon style={{ color: 'green' }} />
                                  </ListItemIcon>
                                  <ListItemText primary={kf.feature} />
                                </ListItem>
                              ))}
                            </List>
                          )}
                        </>
                      )}
                      {isExpanded && (
                        <>
                          <IconButton
                            onClick={() => toggleCardExpand(index)}
                            sx={{
                              position: 'absolute',
                              top: '8px',
                              left: '8px',
                            }}
                          >
                            <ArrowBackIosIcon fontSize="small" />
                          </IconButton>
                          {/* Expanded View Layout */}
                          <Grid container spacing={2} sx={{ mt: 4 }}>
                            {/* Left column: Details screen imageOrhyD*/}
                            <Grid item xs={12} sm={4}>
                              {product.details_screen_image && (
                                <img
                                  src={product.details_screen_image}
                                  alt={product.product_name}
                                  style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                  }}
                                />
                              )}
                            </Grid>
                            {/* Right column: Downloads, Pitch, Videos */}
                            <Grid item xs={12} sm={8}>
                              <Box sx={{ mb: 2 }}>
                                {/* Download Links */}
                                <Grid container spacing={1}>
                                  {[
                                    { label: 'brochure', url: product.brochure },
                                    { label: 'product_ppt', url: product.product_ppt },
                                    { label: 'terms_and_conditions', url: product.terms_and_conditions },
                                    { label: 'one_pager', url: product.one_pager },
                                  ].map((doc, i) =>
                                    doc.url ?(
                                      <Grid item key={i}>
                                        <Tooltip
                                          title={doc.label.replace('_', ' ').toUpperCase()}
                                        >                                    
                                          <Button                                                          
                                            variant="outlined"                                                                              
                                            size="small"                                                                              
                                            startIcon={getIconForLabel(doc.label)}                                                                              
                                            onClick={() => openExternalLink(doc.url)}                                                                              
                                          >
                                            {doc.label.toUpperCase()}
                                          </Button>
                                        </Tooltip>
                                      </Grid>
                                    ) : null
                                  )}
                                </Grid>
                              </Box>
                              {/* 30-Second Pitch */}
                              <Typography
                                variant="body2"
                                component="div"
                                sx={{ mb: 2 }}
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(product.thirty_seconds_pitch),
                                }}
                              />
                              {/* Comparing Returns URL */}
                              {product.comparing_returns_url && (
                                <Button
                                  variant="text"
                                  onClick={() => openExternalLink(product.comparing_returns_url)}
                                  sx={{ mb: 2, textTransform: 'none' }}
                                >
                                  Compare Returns
                                </Button>
                              )}
                              {/* Videos */}
                              {product.videos &&
                                product.videos.map((video, vidIndex)=> {
                                  if (video.video_status === 'Active') {
                                    return (
                                      <Box
                                       key={vidIndex}
                                       sx={{ display: 'flex', alignItems: 'center', mb: 2 }}
                                      >
                                        {video.videoThumbnailImage && (                                                                              
                                          <img                                                                              
                                            src={video.videoThumbnailImage}                                                                              
                                            alt="Video Thumbnail"                                                                              
                                            style={{                                                                              
                                              width: '100px',                                                                              
                                              height: 'auto',                                                                              
                                              cursor: 'pointer',                                                                              
                                              marginRight: '8px',                                                                              
                                            }}                                                                              
                                            onClick={() => openVideoPopup(video.videoLink)}                                                                              
                                          />                                                                              
                                        )}                                                                              
                                        <IconButton                                                                              
                                          onClick={() => openVideoPopup(video.videoLink)}                                                                              
                                        >                                                                              
                                          <PlayCircleIcon color="primary" />                                                                              
                                        </IconButton>
                                      </Box>
                                    );
                                  }
                                  return null;
                                })}
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </Card>
                  </Grid>
                );
              })}
            </Grid>
          </Box>
        )}
        {/* Final button */}
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleProceed}
            disabled={processing || (strategy === '2' && localSelectedProducts.length === 0)}
            sx={{
              paddingX: 4,
              paddingY: 1.5,
              fontSize: '1rem',
              borderRadius: 2,
              boxShadow: 3,
              '&:hover': {
                boxShadow: 6,
              },
            }}
          >
            {processing ? 'Processing...' : nextStepLabel}
          </Button>
        </Box>
      </motion.div>
    </Container>
  );
}
export default AgentStrategy;
